export const TZ = 'Europe/Rome';
export const CURRENT_USER = 'You';

export const USER_DIRECTORY = [
  { handle: '@giuseppe', label: 'Giuseppe (Admin)' },
  { handle: '@mario', label: 'Mario R.' },
  { handle: '@anna', label: 'Anna L.' },
  { handle: '@lucia', label: 'Lucia KYC' },
  { handle: '@andrea', label: 'Andrea Ops' },
  { handle: '@sara', label: 'Sara Compliance' },
  { handle: '@paolo', label: 'Paolo Finance' },
  { handle: '@devteam', label: 'Dev Team' },
];

export function lastMentionQuery(raw) {
  const parts = (raw || '').split(/\s+/).filter(Boolean);
  const last = parts.length ? parts[parts.length - 1] : '';
  const m = last.match(/^@([a-zA-Z0-9_-]{1,32})$/);
  return m ? m[1] : '';
}

export function replaceLastMention(raw, handle) {
  const s = raw || '';
  if (!s.trim()) return handle + ' ';
  if (/(^|\s)@([a-zA-Z0-9_-]{1,32})$/.test(s)) {
    return s.replace(/(^|\s)@([a-zA-Z0-9_-]{1,32})$/, (_m, p1) => (p1 || '') + handle) + ' ';
  }
  return s.trimEnd() + ' ' + handle + ' ';
}

export function canEditActivity(a) {
  return a.type === 'UserTask' && (a.createdBy || '') === CURRENT_USER;
}

export function uid(prefix = 'act') {
  return `${prefix}_${Math.random().toString(16).slice(2)}_${Date.now().toString(16)}`;
}

function pad2(n) {
  return n < 10 ? `0${n}` : `${n}`;
}

export function fmtDateISO(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function fmtTime(d) {
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function monthName(m) {
  return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][m];
}

export function weekdayShort(i) {
  return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'][i];
}

export function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
}

export function endOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
}

export function addMonths(d, delta) {
  return new Date(d.getFullYear(), d.getMonth() + delta, Math.min(d.getDate(), 28));
}

export function addYears(d, delta) {
  return new Date(d.getFullYear() + delta, d.getMonth(), Math.min(d.getDate(), 28));
}

export function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function clamp(n, a, b) {
  return Math.max(a, Math.min(b, n));
}

export function normalizeType(t) {
  return t;
}

export function typeLabel(t) {
  const map = { UserTask: 'Task', Login: 'Access', Order: 'Order', Receive: 'Receive', Send: 'Send', PasswordChange: 'Password', Security: 'Security' };
  return map[t] || 'System';
}

export function typeAccent(t) {
  const map = { UserTask: 'var(--c-teal)', Login: 'var(--c-cyan)', Order: 'var(--c-violet)', Receive: 'var(--c-lime)', Send: 'var(--c-amber)', PasswordChange: 'var(--c-rose)', Security: 'var(--c-red)' };
  return map[t] || 'var(--c-slate)';
}

export function money(n, cur) {
  if (typeof n !== 'number') return '';
  const s = n.toLocaleString(undefined, { maximumFractionDigits: 2 });
  return `${s}${cur ? ` ${cur}` : ''}`;
}

export function withinRange(d, a, b) {
  return d.getTime() >= a.getTime() && d.getTime() <= b.getTime();
}

export function safeParseDate(iso) {
  const d = new Date(iso);
  return isNaN(d.getTime()) ? new Date() : d;
}

export function parseMentions(raw) {
  const found = (raw || '').split(/\s+/).map(s => s.trim()).filter(Boolean).flatMap(tok => {
    const m = tok.match(/^@([a-zA-Z0-9_-]{2,32})$/);
    return m ? ['@' + m[1]] : [];
  });
  return Array.from(new Set(found));
}

/** Map API calendar item to Activity shape. API: { _id, title, start, end, allDay, description, status, user_id, priority, index } */
export function mapApiItemToActivity(item) {
  const start = item.start || item.end;
  const dateOnly = typeof start === 'string' && start.length <= 10;
  const at = dateOnly ? `${start}T12:00:00.000Z` : new Date(start).toISOString();
  return {
    id: item._id,
    title: item.title || 'Untitled',
    type: 'UserTask',
    at,
    note: item.description || undefined,
    meta: { status: item.status, priority: item.priority, user_id: item.user_id },
    createdBy: CURRENT_USER,
    visibility: 'private',
  };
}

export const DEFAULT_TYPE_FILTER = { UserTask: true, Login: true, Order: true, Receive: true, Send: true, PasswordChange: true, Security: true, System: true };
